import React from "react";

export default function SQL_OR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_OR</h1>
      <p>This is the SQL_OR component generated from the SQL JSON.</p>
    </div>
  );
}
